// @generated by protoc-gen-es v1.2.0 with parameter "target=js+dts"
// @generated from file auth/v1/auth.proto (package auth.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message auth.v1.LoginRequest
 */
export const LoginRequest = proto3.makeMessageType(
  "auth.v1.LoginRequest",
  () => [
    { no: 1, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message auth.v1.LoginResponse
 */
export const LoginResponse = proto3.makeMessageType(
  "auth.v1.LoginResponse",
  () => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message auth.v1.RegisterRequest
 */
export const RegisterRequest = proto3.makeMessageType(
  "auth.v1.RegisterRequest",
  () => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "first_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "last_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message auth.v1.RegisterResponse
 */
export const RegisterResponse = proto3.makeMessageType(
  "auth.v1.RegisterResponse",
  [],
);

/**
 * @generated from message auth.v1.ChangePasswordRequest
 */
export const ChangePasswordRequest = proto3.makeMessageType(
  "auth.v1.ChangePasswordRequest",
  () => [
    { no: 1, name: "old_password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "new_password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message auth.v1.ChangePasswordResponse
 */
export const ChangePasswordResponse = proto3.makeMessageType(
  "auth.v1.ChangePasswordResponse",
  [],
);

/**
 * @generated from message auth.v1.LogoutRequest
 */
export const LogoutRequest = proto3.makeMessageType(
  "auth.v1.LogoutRequest",
  [],
);

/**
 * @generated from message auth.v1.LogoutResponse
 */
export const LogoutResponse = proto3.makeMessageType(
  "auth.v1.LogoutResponse",
  [],
);

